require('./scheduleGameController');

"use strict";

angular.module('app.schedule.scheduleGame.scheduleGameDirective', [
    'app.schedule.scheduleGame.scheduleGameController'
])
    .directive('scheduleGame', [
        function () {
            return {
                restrict: 'E',
                templateUrl: 'components/schedule/scheduleGame/scheduleGameView.html',
                controller: 'app.schedule.scheduleGame.scheduleGameController',
                scope: {
                    game: '=',
                    layout: '@?',
                    isCollapsed: '=?'
                },
                link: function (scope, elm) {
                    if (!scope.layout) {
                        scope.layout = 'default';
                    }
                    elm.addClass('layout-' + scope.layout);
                }
            }
        }
    ]);


// WEBPACK FOOTER //
// ./app.v2/components/schedule/scheduleGame/scheduleGameDirective.js